import { useCallback } from 'react';
import { supabase, getSupabaseToken } from '../lib/supabase';
import { timeoutSignal } from '../utils/presensiDiagnostics';

// Batas waktu cek izin supaya presensi tidak menggantung di jaringan lemah.
// Bila habis, dianggap tidak ada izin (pegawai tetap bisa mengisi alasan).
const CEK_IZIN_TIMEOUT_MS = 8000;

export interface IzinTerlambatData {
    id: string;
    jam_mulai: string | null;
    status: string;
}

export const useCekIzinTerlambat = () => {
    const cekIzinTerlambat = useCallback(async (
        userId: string,
        email: string,
        dateStr: string // Format: YYYY-MM-DD
    ): Promise<IzinTerlambatData | null> => {
        try {
            // Tunggu token dulu supaya batas waktu query di bawah hanya mengukur
            // permintaan ke Supabase (bukan pengambilan token yang bisa lebih lama).
            await getSupabaseToken();

            const { data, error } = await supabase
                .from('izin_staf')
                .select('id, jam_mulai, status')
                .eq('jenis_izin', 'Terlambat')
                .eq('status', 'Disetujui')
                .eq('tanggal_mulai', dateStr)
                .or(`id_pegawai.eq.${userId},email.eq.${email}`)
                .limit(1) // izin ganda di hari yang sama tidak boleh membuat query error
                .abortSignal(timeoutSignal(CEK_IZIN_TIMEOUT_MS))
                .maybeSingle();

            if (error) {
                console.error('Error checking izin terlambat:', error);
                return null;
            }

            return data as IzinTerlambatData;
        } catch (err) {
            console.error('Unexpected error checking izin terlambat:', err);
            return null;
        }
    }, []);

    return { cekIzinTerlambat };
};
